module.exports = __webpack_public_path__ + "adf5903a293cc871eb017ea34436c4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/collaboration-graphics.png
// module id = 2297
// module chunks = 1